<template>
    <div class="root">

    </div>
</template>
<script>
    export default {
        data() {
            return {
              leshuaID:0,
              orderSn:'',
              code:''
            };
        },
        watch:{

        },
        methods: {

        },
        created: function () {
            this.orderSn = this.$route.query.orderSn;
            this.leshuaID = this.$route.query.leshuaID;
            this.code = this.$route.query.code;
            if(!this.code){
              this.fetchData("/base/getAuthUrlByLeshua",{id:this.leshuaID,orderSn:this.orderSn,url:location.href},res=>{
                if(res.code){
                    window.location.href = res.url
                }else{
                  this.$toast(res.msg)
                }
              })
            }else{
              this.fetchData("/base/getBalancePaymentByLeshua",this.$route.query,res=>{
                if(res.code){
                  WeixinJSBridge.invoke(
                    "getBrandWCPayRequest", res.data,
                    (res) => {
                      if (res.err_msg == "get_brand_wcpay_request:ok") {
                        this.$toast.success("支付成功")
                        this.$router.push({name: 'home'})
                      }
                    }
                  )
                }else{
                  this.$toast(res.msg)
                }
              })

            }
        }
    };
</script>
<style lang="scss" scoped>
.root{
  .expireDate{
    text-align: center;
    color: #ff2e2e;
    font-size: .24rem;
    position: fixed;
    width: 6.9rem;
    left: 0.3rem;
    margin: 0 auto;
    line-height: .7rem;
    font-size: .28rem;
    bottom: 1.2rem;
  }
  .top-bg{
    background: #fafafa;
    border-bottom-left-radius: .3rem;
    border-bottom-right-radius: .3rem;
    height: 1rem;
    line-height: .52rem;
    font-size: .3rem;
    font-weight: bold;
    text-align: left;
    padding: .3rem 0 0 .3rem;
    .number{
      color: #0051fe;
      text-align: left;
    }
  }
  .submit-bnt{
    width: 6.9rem;
    left: .3rem;
    margin: 0 auto;
    height: .7rem;
    line-height: .7rem;
    text-align: center;
    color: #fff;
    background: #0353fe;
    font-size: .28rem;
    border-radius: .24rem;
    position: fixed;
    bottom: .6rem;
  }
  .package-list{
    margin: -.3rem auto 0;
    width: 6.9rem;
    padding-bottom: 1.8rem;
    .package-list-item{
      padding: .3rem;
      background: #fff;
      box-shadow: 0 0 .1rem #f2f6ff;
      border-radius: .3rem;
      margin-bottom: .16rem;
      .line-1{
        display: flex;
        :first-child{
          flex: 2;
          text-align: left;
          font-weight: bold;
          font-size: .3rem;
          color: #242424;
        }
        :last-child{
          flex: 1;
          text-align: right;
          font-size: .3rem;
        }
      }
      .line-2{
        display: flex;
        font-size: .26rem;
        line-height:.74rem;
        :first-child{
          flex: 2;
          text-align: left;
          color: #242424;
        }
        :last-child{
          flex: 1;
          text-align: right;
          color: #ffa34b;
        }
      }
      .line-3{
        color: #666666;
        font-size: .24rem;
        line-height: .38rem;
        letter-spacing: .02rem;
        border-top: 1px solid #f5f6f9;
        padding-top: .2rem;
      }
    }
    .package-list-item.active{
      background: #0353fe;
      .line-1{
        :first-child{
          color: #fff;
        }
        :last-child{
          flex: 1;
          text-align: right;
          font-size: .3rem;
        }
      }
      .line-2{
        display: flex;
        font-size: .26rem;
        line-height:.74rem;
        :first-child{
          flex: 2;
          text-align: left;
          color: #fff;
        }
        :last-child{
          flex: 1;
          text-align: right;
          color: #fff;
        }
      }
      .line-3{
        color: #fff;
        font-size: .24rem;
        line-height: .38rem;
        letter-spacing: .02rem;
        border-top: 1px solid #fff;
        padding-top: .2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/leshuapayment.vue